import { sumBy } from 'lodash';
import shopSelectors from 'services/shop/selectors';
import { parseDecimal } from 'utils/formatCurrency';
import { IGroupCustomerItem } from '../types';

const useGetDepositValue = (): ((customers?: IGroupCustomerItem[] | undefined) => number) => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();
  const getDepositValue = (customers?: IGroupCustomerItem[] | undefined) => {
    if (!customers) return 0;
    if (!settingDeposit) return 0;
    if (settingDeposit?.depositType === 'PERCENT') {
      const total = sumBy(customers, o => o.services.reduce((acc, service) => acc + (service.price || 0), 0) || 0) || 0;
      return parseDecimal(total * (settingDeposit?.depositValue / 100));
    }
    return settingDeposit?.depositValue;
  };

  return getDepositValue;
};

export default useGetDepositValue;
